export const ASSIGNABLE_TENANT_ROLE_CODES: readonly string[] = ['USER', 'TENANT_ADMIN'];
